import { render } from "./RTLSupport.vue?vue&type=template&id=b3e4ccae&scoped=true&ts=true"
import script from "./RTLSupport.vue?vue&type=script&lang=ts"
export * from "./RTLSupport.vue?vue&type=script&lang=ts"

import "./RTLSupport.vue?vue&type=style&index=0&id=b3e4ccae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3e4ccae"]])

export default __exports__